module.exports = __webpack_public_path__ + "media/11.9e11811d.mp3";